import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2912ab0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "col-12" }, "Volledig archief:")
], -1))
const _hoisted_4 = { class: "row archief-wrapper" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Meest recente monitors:", -1))
const _hoisted_9 = { class: "topicCols" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_page_subtitle = _resolveComponent("page-subtitle")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_textbox = _resolveComponent("textbox")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_page_title, {
            text: _ctx.$t('bromonitor_archief.titel')
          }, null, 8, ["text"]),
          _createVNode(_component_page_subtitle, {
            text: _ctx.$t('bromonitor_archief.subtitel')
          }, null, 8, ["text"])
        ])
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          "aria-label": "datum selectie lijst",
          name: "archive-select",
          id: "archive-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToDateMonitor()))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: opt.value as string,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_5))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.date]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createElementVNode("li", { key: index }, [
                (_ctx.dates.length > index - 1)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
                name: 'bro-monitor',
                query: { datum: _ctx.formatDate(_ctx.dates[index - 1].value) },
              },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_10, [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            name: "keyboard_arrow_right"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.dates[index - 1].label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ])
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_textbox, {
          text: _ctx.$t('bromonitor_archief.uitleg')
        }, null, 8, ["text"])
      ])
    ]),
    _: 1
  }))
}